import httpUserClient from '@/plugins/httpUserClient';

export default {
  getAppointments(currentPage) {
    return httpUserClient.get(`user/meeting/appointments?page=${currentPage}&per_page=10`);
  },
  cancelAppointment(id) {
    return httpUserClient.delete(`user/meeting/appointments/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/meeting/appointmentsApis.js